module.exports = __webpack_public_path__ + "static/media/googlepay.954eb479.png";